<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="title" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8" id="main">
                    <div id="page-selector" class="page-selector row py-4 py-lg-5 justify-content-center">
                        <div class="page-tab col" id="profile">
                            <router-link :to="'/chara/' + title + '/profile'">简介</router-link>
                        </div>
                        <div class="page-tab col" id="story">
                            <router-link :to="'/chara/' + title + '/story'">故事</router-link>
                        </div>
                        <div class="page-tab col" id="closet">
                            <router-link :to="'/chara/' + title + '/closet'">衣柜</router-link>
                        </div>
                        <div class="page-tab col" id="gallery">
                            <router-link :to="'/chara/' + title + '/gallery'">图库</router-link>
                        </div>
                    </div>
                    <router-view :charas="charas" :articles="articles" />
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import service from '../utils/request'
import { useCache } from '../utils/usecache'

let route = useRoute()
const title = route.params.name[0]
let router = useRouter()
const current_page_name = router.currentRoute.value.name
const charas = ref()
const articles = ref()

watch(
    () => router.currentRoute.value.name,
    (newValue, oldValue) => {
        if (newValue != oldValue) {
            var new_page = '#' + newValue
            var old_page = '#' + oldValue
            $(new_page).removeClass('page-tab')
            $(new_page).addClass('page-tab-selected')
            $(old_page).removeClass('page-tab-selected')
            $(old_page).addClass('page-tab')
        }
    }
)

const getCharaNameList = async () => {
    try {
        const rst = await useCache('charaNameList', () => {
            return service.get("/user/chara/listName").then(res => res.data)
        })
        if (rst?.length && rst[0] != null) {
            charas.value = rst.reduce((acc, item) => {
                acc[item.id] = item.name
                return acc
            }, {})
        } else {
            console.error('返回角色信息为空')
        }
    } catch (error) {
        console.error('获取角色信息失败', error)
    }
}

onMounted(() => {
    var current_page = '#' + current_page_name
    $(current_page).removeClass('page-tab')
    $(current_page).addClass('page-tab-selected')
    getCharaNameList();
})

</script>
<style scoped>
.page-tab {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: skyblue;
    text-align: center;
    margin-right: 4px;
}

.page-tab a {
    color: white;
}

.page-tab:hover {
    background-color: rgba(135, 206, 235, 0.2);
}

.page-tab:hover a {
    color: skyblue;
}

.page-tab-selected {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: MediumTurquoise;
    text-align: center;
    margin-right: 4px;
}

.page-tab-selected a {
    color: white;
}

.info {
    background-color: white;
    padding: 2%;
}
</style>
